export default __webpack_public_path__ + "static/media/Digital Keys.daf98659.svg";